import { addAudit, editAudit, auditDetail, markList, typeList } from './request';
import { applicationResource } from './../../customer/applicationManage/request';
import { customerResource } from './../../system/customerManage/request';
export default {
  data() {
    return {
      dataFrom: {},
      dialogVisible: false,
      customerList: [],
      applicationList: [],
      markList: markList,
      typeList: typeList
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('审核流名称')
        }],
        type: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('审核流类型')
        }],
        mark: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('标识')
        }],
        customerId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('归属客户')
        }],
        applicationId2: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('归属应用')
        }]
      };
    }
  },
  methods: {
    init(id) {
      customerResource().then(res => {
        this.customerList = res;
      });
      if (id) {
        auditDetail({
          auditFlowId: id
        }).then(res => {
          this.dataFrom = res;
          this.dataFrom.applicationId2 = [res.applicationId];
          this.getDataFun();
        });
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.dataFrom.applicationId = this.dataFrom.applicationId2.join(',');
          let fun = this.dataFrom.auditFlowId ? editAudit : addAudit;
          fun(this.dataFrom).then(() => {
            this.$message.success(this.$t('添加成功') + '!');
            this.$emit('cancel');
            this.$emit('ok');
          });
        }
      });
    },
    getDataFun() {
      applicationResource({
        customerId: this.dataFrom.customerId
      }).then(res => {
        console.log(res, 5555);
        this.applicationList = res;
      });
    }
  }
};